import { Api } from "../utils";

const PublicationsActions = {

  async GetAll(skipCount, maxResultCount) {
    const params = new URLSearchParams({ skipCount, maxResultCount });

    const url = `services/app/Publication/GetAll?${params}`;
    try {
      const response = await Api.fetchAsync(url);
      Api.validateResponse(response, url);
      const { result } = await response.json();
      return result;
    } catch (e) {
      return null;
    }
  },  
};

export default PublicationsActions;